//eslint-disable-next-line @typescript-eslint/ban-types
export function ClassDecoratorFactory(callback, proxyHandler) {
    return function (options) {
        return function (constructor) {
            const fn = function (...params) {
                const result = new Proxy(new constructor(...params), proxyHandler);
                callback(result, options);
                return result;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            };
            fn.prototype = constructor.prototype;
            return fn;
        };
    };
}
//# sourceMappingURL=ClassDecoratorFactory.js.map